<template>
<div class="invoice-detail-modal">
   <el-dialog title="发票明细" v-model="showModal" @close="closeModal"
    :close-on-click-modal="false">
    <div class="table-box" v-if="invoiceDetail.detail">
      <table class="invoices-table">
        <thead>
          <tr>
            <th class="th" width="80">订单号</th>
            <th class="th">商品名称</th>
            <th class="th" width="93">出行人</th>
            <th class="th" width="110">支付时间</th>
            <th class="th" width="132">订单金额<br />（不含退款）</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in invoiceDetail.detail.detail_list" :key="item.order_id">
            <td class="td">{{item.order_id}}</td>
            <td class="td">{{item.product_name}}</td>
            <td class="td">{{item.applicant_name}}</td>
            <td class="td">{{item.pay_time.substring(0, 16)}}</td>
            <td class="td">¥ {{toFixed2(item.pay_amount)}}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button type="primary" class="download-btn" @click="onDownload"
        >下载</el-button
      >
    </div>
  </el-dialog>

</div>
</template>

<script>
import invoiceApi from '../../../api/invoice-api';
import utils from '../../../libs/utils';

export default {
  name: '',
  components: {},
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false,
    },
    invoice: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },

  },
  data() {
    return {
      showModal: false,
      invoiceDetail: {},
    };
  },
  computed: {
  },
  watch: {
    value(newVal) {
      this.showModal = newVal;
      if (newVal) {
        this.init();
      }
    },
    showModal(newVal) {
      this.$emit('input', newVal);
    },
  },
  created() {
  },
  methods: {
    init() {
      this.getInvoiceDetail();
    },
    closeModal() {
      this.showModal = false;
    },
    // 获取发票详情
    getInvoiceDetail() {
      invoiceApi.invoiceQuery({
        order_invoice_id: this.invoice.id,
      }).then((data) => {
        this.invoiceDetail = data;
      });
    },
    // 保留两位小数
    toFixed2(price) {
      return (price / 100).toFixed(2);
    },
    onDownload() {
      const url = this.invoiceDetail.detail && this.invoiceDetail.detail.detail_url;
      if (!url) {
        return utils.msg.error('文件生成中，请稍后重试。');
      }
      window.open(`${url}?response-content-type=application/octet-stream&v=${Math.random()}`);
    },
  },
};
</script>

<style scoped lang="less">
.invoice-detail-modal {
  /deep/ .el-dialog {
    width: 600px;
    .el-dialog__header {
      height: 60px;
      border-bottom: 1px solid #e9eef2;
      .el-dialog__title{
        font-weight: 600;
      }
    }
    .el-dialog__body {
      padding: 16px 24px;
    }
    .el-dialog__footer {
      border-top: 1px solid #e9eef2;
      padding: 16px 24px;
      .dialog-footer {
        .download-btn {
          height: 48px;
          background: #599FFF;
          border-radius: 4px;
          width: 116px;
          font-size: 18px;
        }
      }
    }
  }
  .table-box{
    .invoices-table {
      width: 100%;
      border-spacing: 0;
      border-top: 1px solid #DEE2E6;
      border-left: 1px solid #DEE2E6;
      thead {
        background: #FAFBFC;
        tr {
          height: 48px;
          th {
            font-size: 14px;
            color: #2f333d;
            line-height: 20px;
            border-bottom: 1px solid #DEE2E6;
            text-align: center;
            padding: 0 12px;
            font-weight: 400;
            &:nth-child(2){
              text-align: left;
            }
            &:last-child{
              border-right: 1px solid #DEE2E6;
            }
          }
        }
      }
      tbody{
        tr{
          td{
            padding: 12px;
            border-right: 1px solid #DEE2E6;
            border-bottom: 1px solid #DEE2E6;
            font-size: 14px;
            color: #2F333D;
            line-height: 20px;
            text-align: center;
            &:nth-child(2){
              text-align: left;
            }
          }
        }
      }

    }
  }

}
</style>



// WEBPACK FOOTER //
// src/pages/invoice-manage/components/invoice-detail-modal.vue